import { LocaleData, TranslationData } from "../types";

export function mergeMessages(
  locale: LocaleData,
  translations: TranslationData
): LocaleData {
  return {
    ...locale,
    messages: {
      ...locale.messages,
      ...translations,
    },
  };
}
